import { Icon } from '@chakra-ui/react'
import { TbProgressCheck } from 'react-icons/tb'

function Progress() {
    return <Icon as={TbProgressCheck} boxSize={5} color="gray" />
}

export default Progress
